import React from 'react';
import { animated } from 'react-spring';

import { profileIcon, searchIcon } from '../../../../utils/icons';

import { AnimateState } from '../../animations/animate';
import useAnimate from '../../animations/hooks/useAnimate';

import styles from './Header.module.scss';

type Props = {
    title?: string,
    left?: { icon: string, onClick: () => void } | null,
    right?: { icon: string, onClick: () => void } | null,
};

export default function Header({ title, left, right }: Props) {
    const { animate } = useAnimate();

    return (
        <>
            <div className={styles.header}>
                <animated.div
                    className={styles.headerGradient}
                    style={{
                        opacity: animate(alpha => ({
                            [AnimateState.Default]: 1,
                        })),
                    }}
                />

                <div className={styles.headerItem} onClick={left?.onClick}>
                    <div className="icon" style={{ backgroundImage: left?.icon ? `url(${left.icon})` : undefined }}/>
                </div>

                <div className={styles.headerTitle}>
                    {title ? <span>{title}</span> : <span>Courts in <strong>Kiev</strong></span>}
                </div>

                <div className={styles.headerItem} onClick={right?.onClick}>
                    <div className="icon" style={{ backgroundImage: right?.icon ? `url(${right.icon})` : undefined }}/>
                </div>
            </div>
        </>
    );
}
